import { render, staticRenderFns } from "./DetalhesVendaMultipla.vue?vue&type=template&id=69c52dc5&scoped=true&"
import script from "./DetalhesVendaMultipla.vue?vue&type=script&lang=js&"
export * from "./DetalhesVendaMultipla.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesVendaMultipla.vue?vue&type=style&index=0&id=69c52dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c52dc5",
  null
  
)

export default component.exports